import * as R from "ramda";
import React, { Component, Fragment } from "react";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../modules/custom/customTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import MasterPackageH2Modifying from "./components/MasterPackageH2Modifying";
import MasterPackageH2Filter from "./components/MasterPackageH2Filter";
import Api from "../../../Services/Api";
import {
  flattenFormGroupObject,
  getValueFromArrayDDL,
  mapToObjectDDL,
  removeNullFields,
} from "../../common/mapper";
import { formGroup, tableColumns } from "./config/config";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import { getValueItemFromArrayDDL } from "./util";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { contructQueryParam, fetchDataAsync } from "../../../Services/Utils";
import { HttpStatus } from "../../common/Constants";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleDDL from "../../../modules/SimpleDDL";

class MasterPackageH2 extends Component {
  constructor(props) {
    super(props);
    this.initialSearch = {
      kodeVariant: null,
      kodeCabang: [],
    };
    this.state = {
      loading: false,
      modifyingVisible: false,
      copyVisible: false,
      warningVisible: false,
      inputValue: null,
      warningMessage: null,
      warningAction: null,
      useActionState: null,
      tableColumns: [
        ...tableColumns.mainPage,
        {
          name: "",
          label: "Action",
          options: {
            customBodyRender: (_, tableMeta) => {
              return (
                <FlexView vAlignContent="center" style={{ gap: 10 }}>
                  <SimpleButton
                    category="action_button"
                    style={{ backgroundColor: "transparent" }}
                    disabled={!this.props.menuAccess[0].updateAccess}
                    icon={
                      <i
                        style={{
                          fontSize: 20,
                          color: this.props.menuAccess[0].updateAccess
                            ? "red"
                            : "black",
                        }}
                        className="fa fa-lw fa-pencil-alt"
                      />
                    }
                    onClick={() =>
                      this.handleModifyingModalVisibility(
                        tableMeta.rowIndex,
                        "edit"
                      )
                    }
                  />
                  <ToggleButton
                    value={R.equals(
                      this.state.dataTable[tableMeta.rowIndex].status,
                      "ACTIVE"
                    )}
                    onToggle={() => this.handleToggleClick(tableMeta.rowIndex)}
                  />
                  <SimpleButton
                    category="action_button"
                    disabled={!this.props.menuAccess[0].createAccess}
                    style={{ backgroundColor: "transparent" }}
                    icon={
                      <i
                        style={{
                          fontSize: 20,
                          color: this.props.menuAccess[0].createAccess
                            ? "red"
                            : "black",
                        }}
                        className="fa fa-copy"
                      />
                    }
                    onClick={() =>
                      this.handleCopyModalVisibility(tableMeta.rowIndex)
                    }
                  />
                </FlexView>
              );
            },
            sort: false,
          },
        },
      ],
      selectedData: null,
      selectedRowIndex: null,
      payload: null,
      dataTable: [],
      dataVariant: [],
      pagination: {
        count: 0,
        limit: 5,
        page: 1,
        orderBy: "id",
        sort: "ASC",
      },
      filterVisible: false,
      submitedFilter: null,
      search: { ...this.initialSearch },
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    await this.fetchData();
    this.fetchDataCabang();
    this.fetchDataVarian();

    this.handleTriggerLoading();
  };

  fetchDataCabang = async () => {
    try {
      this.handleTriggerLoading();
      const res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();

      if (res.ok && Array.isArray(res.data?.data)) {
        const allowedCabang = this.props.menuAccess.map(
          (item) => item.idRefObj
        );

        const filteredData = res.data.data.filter((item) =>
          allowedCabang.includes(item.kodeCabang)
        );

        if (filteredData.length > 0) {
          const ddlOptions = filteredData.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang)
          );

          this.setState((prevState) => ({
            ...prevState,
            dataCabang: filteredData,
            cabangOptions: ddlOptions,
          }));
        }
      }
    } catch (error) {
      // console.error("Error fetchDataCabang:", error);
    } finally {
      this.handleTriggerLoading();
    }
  };

  fetchDataVarian = async () => {
    try {
      let response = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataVariant: response.data.data,
        }));
      }
    } catch (error) {
      // console.log("errors: ", error);
    }
  };

  handleModifyingModalVisibility = (index, mode = "add") => {
    this.setState((prevValue) => ({
      ...prevValue,
      selectedData: !R.isNil(index) ? prevValue.dataTable[index] : null,
      modifyingVisible: !prevValue.modifyingVisible,
      useActionState: mode,
    }));
  };

  handleCopyModalVisibility = async (index) => {
    if (!R.isNil(index)) {
      const selectedData = this.state.dataTable[index];

      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterPackageH2ById,
        menuName: "Master Package H2",
        setError: this.props.setError,
        args: contructQueryParam({ packageId: selectedData.packageId }),
      });
      if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        this.setState((prevValue) => ({
          ...prevValue,
          copyVisible: !prevValue.copyVisible,
          selectedData: selectedData,
          inputValue: null,
          errorMessage: null,
        }));
      }
    } else {
      this.setState((prevValue) => ({
        ...prevValue,
        copyVisible: !prevValue.copyVisible,
        selectedData: null,
        inputValue: null,
        errorMessage: null,
      }));
    }
  };

  handleWarningModalVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      warningVisible: !prevValue.warningVisible,
    }));
  };

  handleToggleClick = (rowIndex) => {
    this.setState(
      (prevValue) => ({
        ...prevValue,
        // warningVisible: !prevValue.warningVisible,
        warningAction: "update",
        selectedRowIndex: rowIndex,
      }),
      () => this.handleChangeStatus()
    );
  };

  handleSaveClick = (payload) => {
    this.setState((prevValue) => ({
      ...prevValue,
      warningVisible: !prevValue.warningVisible,
      warningAction: "save",
      payload: payload,
    }));
  };

  handleValueChange = ({ target }) => {
    this.setState((prevValue) => ({
      ...prevValue,
      inputValue: target.value,
    }));
  };

  handleCopy = async (e) => {
    this.handleTriggerLoading();
    e.preventDefault();

    if (!this.state.inputValue) {
      this.setState((prevValue) => ({
        ...prevValue,
        errorMessage: "Field belum diisi",
        loading: false,
      }));
      return;
    } else {
      this.setState((prevValue) => ({
        ...prevValue,
        errorMessage: null,
      }));
    }
    let request = {
      packageId: this.state.selectedData.packageId,
      packageName: this.state.inputValue,
    };

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").copyMasterPackageH2,
      menuName: "Master Package H23",
      setError: this.props.setError,
      args: request,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        copyVisible: !prevValue.copyVisible,
        submitedFilter: null,
        search: this.initialSearch,
      }));
      await this.fetchData();
    }
    this.handleTriggerLoading();
  };

  handleSubmit = async () => {
    if (R.equals(this.state.warningAction, "save")) {
      await this.handleSubmitModifying(this.state.payload);
      this.handleWarningModalVisibility();
    } else {
      await this.handleChangeStatus();
      this.handleSaveClick();
    }
  };

  handleSubmitModifying = async (data) => {
    this.handleTriggerLoading();

    const isAddAction = this.state.useActionState === "add";
    const selected = this.state.selectedData;

    let parsedData = {
      ...flattenFormGroupObject(data),
      gracePeriod:
        Number(flattenFormGroupObject(this.state.payload).gracePeriod) || null,
      kodeCabang: getValueFromArrayDDL(this.state.payload, "kodeCabang"),
      kodeVariant: getValueFromArrayDDL(this.state.payload, "kodeVariant"),
      part: getValueItemFromArrayDDL(this.state.payload, "part"),
      service: getValueItemFromArrayDDL(this.state.payload, "service"),
      packageId: isAddAction ? null : selected?.packageId || null,
    };

    delete parsedData.packageSpecificCabang;
    delete parsedData.status;

    let res = await this.callApi(
      Api.create("NAGAMAS_MASTER_DATA").saveMasterPackageH2,
      parsedData
    );
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleModifyingModalVisibility();
      this.setState(
        (prev) => ({
          ...prev,
          submitedFilter: null,
          search: this.initialSearch,
        }),
        async () => await this.fetchData()
      );
      await this.fetchData();
    }
    this.handleTriggerLoading();
  };

  handleChangeStatus = async () => {
    this.handleTriggerLoading();
    const { selectedRowIndex, dataTable } = this.state;
    const currentStatus = dataTable[selectedRowIndex].status;
    const newStatus = currentStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE";

    let data = dataTable[selectedRowIndex];
    const request = contructQueryParam({
      packageId: data.packageId,
      status: newStatus,
    });
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateStatusMasterPackageH2,
      setError: this.props.setError,
      menuName: "Master Package H23",
      args: request,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState(
        (prev) => ({
          ...prev,
          submitedFilter: null,
          search: this.initialSearch,
        }),
        async () => await this.fetchData()
      );
    }
    this.handleTriggerLoading();
  };

  handleChangePage = async (tableState) => {
    console.log(this.state.search);

    this.handleTriggerLoading(true);
    try {
      const limit = tableState.rowsPerPage;
      const page = tableState.page + 1;
      const { submitedFilter, search } = this.state;

      let activeFilter = {};

      if (submitedFilter) {
        const arrCabang = submitedFilter.kodeCabang || [];
        activeFilter = {
          ...submitedFilter,
          kodeCabang:
            arrCabang.length > 0 ? arrCabang.map((item) => item.value) : [],
          hasGracePeriod:
            submitedFilter?.noPeriod === null
              ? null
              : submitedFilter?.noPeriod?.value,
        };
      } else {
        const kodeCabang = search?.kodeCabang?.value
          ? [search.kodeCabang.value]
          : [];
        activeFilter = {
          ...search,
          kodeCabang,
        };
      }

      this.setState((prev) => ({
        ...prev,
        pagination: { ...prev.pagination, page, limit },
      }));

      await this.fetchData(removeNullFields(activeFilter), page, limit);
    } finally {
      this.handleTriggerLoading(false);
    }
  };

  handleChangeRowsPerPage = async (tableState) => {
    this.handleTriggerLoading(true);
    try {
      const limit = tableState.rowsPerPage;
      const { submitedFilter, search } = this.state;

      let activeFilter = {};

      if (submitedFilter) {
        const arrCabang = submitedFilter.kodeCabang || [];
        activeFilter = {
          ...submitedFilter,
          kodeCabang:
            arrCabang.length > 0 ? arrCabang.map((item) => item.value) : [],
          hasGracePeriod:
            submitedFilter?.hasGracePeriod === null
              ? null
              : submitedFilter?.hasGracePeriod?.value,
        };
      } else {
        const kodeCabang = search?.kodeCabang?.value
          ? [search.kodeCabang.value]
          : [];
        console.log("kodeCabang:", kodeCabang);

        activeFilter = {
          ...search,
          kodeCabang,
        };
      }

      this.setState((prev) => ({
        ...prev,
        pagination: { ...prev.pagination, count: 0, page: 1, limit },
      }));

      await this.fetchData(removeNullFields(activeFilter), 1, limit);
    } finally {
      this.handleTriggerLoading(false);
    }
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchData = async (body = {}, page, limit) => {
    const { pagination } = this.state;
    const currentPage = page ?? pagination.page;
    const currentLimit = limit ?? pagination.limit;

    this.setState((prevValue) => ({
      ...prevValue,
      pagination: { ...prevValue.pagination, count: 0 },
    }));

    const req = {
      ...body,
      kodeCabang: [].concat(
        body?.kodeCabang || this.state.kodeCabang?.value || []
      ),
      page: currentPage,
      limit: currentLimit,
    };

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getDataMainPagePackageH2,
      menuName: "Master Paket Penjualan H23",
      setError: this.props.setError,
      args: req,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data,
        pagination: {
          ...prevValue.pagination,
          count: res.data.totalData,
          page: currentPage,
          limit: currentLimit,
        },
      }));
    }
  };

  callApi = async (api, args) => {
    return await fetchDataAsync({
      asyncFn: api,
      menuName: "Master Package H23",
      setError: this.props.setError,
      args: args,
    });
  };

  handleFilterModalVisibility = () => {
    this.setState((prev) => ({ ...prev, filterVisible: !prev.filterVisible }));
  };

  handleSubmitFilter = async (payload) => {
    this.handleTriggerLoading(true);
    try {
      this.setState((prev) => ({
        ...prev,
        submitedFilter: payload,
        pagination: { ...prev.pagination, page: 1, limit: 5 },
        filterVisible: false,
        search: this.initialSearch,
      }));

      const request = {
        kodeCabang: Array.isArray(payload.kodeCabang)
          ? payload.kodeCabang.map((c) => c.value)
          : [],
        kodeVariant: payload.kodeVariant?.value || null,
        packageName: payload.packageName || null,
        hasGracePeriod:
          typeof payload.hasGracePeriod?.value === "boolean"
            ? payload.hasGracePeriod.value
            : null,
        period: payload.period?.value || null,
        startPeriod: payload.startDate || null,
        endPeriod: payload.endDate || null,
      };

      await this.fetchData(removeNullFields(request), 1, 5);
    } finally {
      this.handleTriggerLoading(false);
    }
  };

  handleSearchPackage = async () => {
    this.handleTriggerLoading(true);
    try {
      this.setState((prev) => ({
        ...prev,
        submitedFilter: null,
        pagination: { ...prev.pagination, page: 1, limit: 5 },
        filterVisible: false,
      }));

      const { kodeVariant, kodeCabang } = this.state.search;

      const payload = {
        kodeVariant: kodeVariant?.value || null,
        kodeCabang:
          kodeCabang?.value &&
          kodeCabang.value !== null &&
          kodeCabang.value !== ""
            ? [kodeCabang.value]
            : [],
      };

      await this.fetchData(payload, 1, 5);
    } finally {
      this.handleTriggerLoading(false);
    }
  };

  handleChangeDDL = async (name, value) => {
    this.setState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        [name]: value,
      },
    }));
  };

  render() {
    return (
      <Container>
        <FlexView
          style={{ justifyContent: "space-between" }}
          vAlignContent="center"
          className="margin-bottom-20px margin-top-5px"
        >
          <FlexView vAlignContent="center" style={{ gap: "30px" }}>
            <SimpleDDL
              id="select_options_nama_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-250px"
              placeholder="Nama cabang hak akses"
              options={this.state.cabangOptions}
              value={this.state.search.kodeCabang}
              onChange={(value, { name }) => this.handleChangeDDL(name, value)}
            />

            <SimpleDDL
              id="select_options_nama_variant"
              box="search"
              name="kodeVariant"
              containerclassname="width width-250px"
              placeholder="Kode Varian"
              isClearable={true}
              value={this.state.search.kodeVariant}
              options={
                this.state.dataVariant
                  ? this.state.dataVariant.map((item) => ({
                      label: `${item.kodeVariant} - ${item.namaVariant} `,
                      value: item.kodeVariant,
                      name: item.namaVariant,
                    }))
                  : null
              }
              onChange={(value, { name }) => this.handleChangeDDL(name, value)}
            />
            <SimpleButton
              style={{ marginBottom: 15 }}
              onClick={this.handleSearchPackage}
              text="CARI"
            />
          </FlexView>
          <SimpleButton
            onClick={this.handleFilterModalVisibility}
            styles={{ width: "unset" }}
            icon={<i className={"fa fa-qrcode"}></i>}
          />
        </FlexView>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableColumns}
          toCount={this.state.pagination.count}
          rowsPerPage={this.state.pagination.limit}
          page={this.state.pagination.page - 1}
          options={defaultTableChange(
            (tableState) => this.handleChangePage(tableState),
            (tableState) => this.handleChangeRowsPerPage(tableState)
          )}
          footerAdditionalButtons={
            <SimpleButton
              secondary={!this.props.menuAccess[0].createAccess}
              disabled={!this.props.menuAccess[0].createAccess}
              onClick={() => this.handleModifyingModalVisibility(null, "add")}
              icon={<i className="fa fa-plus margin-right-10px"></i>}
              text={"Tambah"}
            />
          }
        />

        {this.state.modifyingVisible && (
          <MasterPackageH2Modifying
            {...this.props}
            formGroup={formGroup}
            initialValues={this.state.selectedData}
            visible={this.state.modifyingVisible}
            onSubmit={this.handleSaveClick}
            onClickClose={() => {
              this.setState({ useActionState: null });
              this.handleModifyingModalVisibility();
            }}
          />
        )}

        {this.state.warningVisible && (
          <SimpleAlert
            title={"Question"}
            content={"Apakah anda yakin?"}
            additionalButtons={
              <Fragment>
                <FlexView>
                  <SimpleButton
                    text="Batal"
                    secondary
                    onClick={() => this.handleWarningModalVisibility()}
                  />
                  <SimpleButton
                    text="Iya"
                    onClick={() => this.handleSubmit()}
                  />
                </FlexView>
              </Fragment>
            }
            visible={this.state.warningVisible}
            onClickClose={this.handleWarningModalVisibility}
          />
        )}

        {this.state.copyVisible && (
          <SimpleModal
            visible={this.state.copyVisible}
            onClickClose={() => this.handleCopyModalVisibility()}
            styles={{
              width: "600px",
              minWidth: "600px",
            }}
            content={
              <ModalContainer style={{ padding: "20px" }}>
                <form onSubmit={this.handleCopy}>
                  <SimpleInput
                    id="input_text_nama_package"
                    name="packageName"
                    label="Nama Paket"
                    mandatory
                    errorMessage={this.state.errorMessage}
                    value={this.state.inputValue}
                    onChange={this.handleValueChange}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                    }}
                  >
                    <SimpleButton type="submit">SIMPAN</SimpleButton>
                  </div>
                </form>
              </ModalContainer>
            }
          />
        )}

        {this.state.filterVisible && (
          <MasterPackageH2Filter
            {...this.props}
            visible={this.state.filterVisible}
            dataVariant={this.state.dataVariant}
            submitedFilter={this.state.submitedFilter}
            onClickClose={this.handleFilterModalVisibility}
            triggerLoading={this.handleTriggerLoading}
            onSubmit={this.handleSubmitFilter}
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(MasterPackageH2);
